export const ACCEPT_SERVICE = {
  APPLICATION_JSON: "application/json",
  MULTIPART_DATA: "multipart/form-data",
  FORM_URL_ENCODED: "application/x-www-form-urlencoded",
  SPREADSHEAT_DATA:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PDF_FILE: "application/pdf",
};
export const DEFAULT_AUTH_TOKEN = "Basic c3RyaXgtdWk6";
export const DEFAULT_ACCEPT_SERVICE = ACCEPT_SERVICE.FORM_URL_ENCODED;
// export const GOOGLE_NETWORK_PING_URL =
//   "https://clients3.google.com/generate_204";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const AuthenticateUrl = process.env.REACT_APP_AUTHENTICATE_URL;

// export const BASE_URL = `http://172.105.59.164:8081/unitrack/api/`

// export const AuthenticateUrl = `http://172.105.59.164:8081/unitrack/api/auth/authenticate`;

// export const BASE_URL = `https://time.unisoftllc.com:8081/unitrack/api/`

// export const AuthenticateUrl = `https://time.unisoftllc.com:8081/unitrack/api/auth/authenticate`;
export class ApiUrl {
  static loginRequest = () => {
    return BASE_URL + "auth/authenticate";
  };
  static forgotPasswordRequest = (email) => {
    return BASE_URL + `auth/forgotpassword?email=${email}`;
  };
  static updatePasswordRequest = () => {
    return BASE_URL + "user/update";
  };
  static resetPasswordRequest = (token) => {
    return BASE_URL + `auth/reset?token=${token}`;
  };
  static userRequest = () => {
    return BASE_URL + `user`;
  };
  static getAllUsers = (page, size, search) => {
    if (search && search.length > 0) {
      return BASE_URL + `user?page=${page}&size=${size}&search=${search}`;
    } else {
      return BASE_URL + `user?page=${page}&size=${size}`;
    }
  };
  static getAllUsersWithOUtPagination = (all) => {
    if (all) {
      return BASE_URL + `user/users?acctType=${all}`;
    } else {
      return BASE_URL + `user/users`;
    }
  };

  static getAllClientsWithOUtPagination = () => {
    return BASE_URL + `admin/clientswithoutpagination`;
  };

  static getUserById = (id) => {
    return BASE_URL + `user/${id}`;
  };
  static editUser = (id) => {
    return BASE_URL + `user/${id}`;
  };
  static addClient = () => {
    return BASE_URL + "admin/client";
  };
  static getAllClients = (page, size, search) => {
    if (search && search.length > 0) {
      return (
        BASE_URL + `admin/clients?page=${page}&size=${size}&search=${search}`
      );
    } else {
      return BASE_URL + `admin/clients?page=${page}&size=${size}`;
    }
  };
  static projectRequest = () => {
    return BASE_URL + "admin/project";
  };
  static projectsListRequest = (page, size, search) => {
    if (search && search.length > 0) {
      return (
        BASE_URL + `admin/projects?page=${page}&size=${size}&search=${search}`
      );
    } else {
      return BASE_URL + `admin/projects?page=${page}&size=${size}`;
    }
  };

  static uploadFile = () => {
    return BASE_URL + "images/imageupload";
  };

  static editProject = (id) => {
    return BASE_URL + `admin/project/${id}`;
  };
  static editClient = (id) => {
    return BASE_URL + `admin/client/${id}`;
  };
  static getClientById = (id) => {
    return BASE_URL + `admin/client/${id}`;
  };
  static getProjectById = (id) => {
    return BASE_URL + `admin/project/${id}`;
  };

  static getProjectsByUserId = (id) => {
    if (id) {
      return BASE_URL + `admin/projects/${id}`;
    } else {
      return BASE_URL + `admin/userassociatedprojects`;
    }
  };

  static getTimeSheetsByProjectId = (uId, pId, date, page, size) => {
    if (date) {
      return (
        BASE_URL +
        `admin/${uId}/${pId}?fromDate=${date}&page=${page}&size=${size}`
      );
    } else {
      return BASE_URL + `admin/${uId}/${pId}?page=${page}&size=${size}`;
    }
  }; 

  static getTimeSheetsByProjectIdForUserPage = (pId, page, size) => {
    return BASE_URL + `timesheet/${pId}?page=${page}&size=${size}`;
  };

  static addTimeSheet = () => {
    return BASE_URL + "timesheet";
  };
  static getTimesheetById = (id) => {
    return BASE_URL + `timesheet/timesheetdetails/${id}`;
  };
  static editTimesheets = (id) => {
    return BASE_URL + `timesheet/edittimesheet/${id}`;
  };
  // static timesheetsAction =(id,action) =>{
  //   return BASE_URL  +`admin/${action}/${id}`
  // }
  static timesheetsAction = (id, action, remarks) => {
    return `${BASE_URL}admin/${action}/${id}?remarks=${encodeURIComponent(
      remarks
    )}`;
  };

  static getBackgroundImage = () => {
    return BASE_URL + "images/get";
  };

  static empStatusRequest = () => {
    return BASE_URL + "admin/adminemployeestatus";
  };
  static getEmpStatusRequest = (id) => {
    return BASE_URL + `admin/employeestatuseinfo/${id}`;
  };

  static getProjectsByuserId = (id, fromDate, toDate) => {
    if (fromDate && toDate) {
      return (
        BASE_URL +
        `admin/projectreportby/${id}?fromDate=${fromDate}&toDate=${toDate}`
      );
    } else {
      return BASE_URL + `admin/projectreportby/${id}`;
    }
  };

  static downloadFileRequest = (id, fileName, action) => {
    return (
      BASE_URL +
      `admin/${
        action === "download" ? "download" : "deleteempdocsfile"
      }/${id}/${fileName}`
    );
  };

  static getAllProjectsWithOutPagination = () => {
    return BASE_URL + `admin/allprojects`;
  };

  static generateProjectReport = () => {
    return BASE_URL + ``;
  };
  static generateInvoice = () => {
    return BASE_URL + `admin/generateinvoice`;
  };
  static getBudgetByProjectId = (pId) => {
    return BASE_URL + `admin/budgetreportby/${pId}`;
  };

  static getDocumentTypesRequest = () => {
    return BASE_URL + `admin/documenttypes`;
  };

  static uploadDocuments = () => {
    return BASE_URL + `admin/upload`;
  };

  static downloadInvoice = (id, invoiceId) => {
    return BASE_URL + `admin/getinvoice/${id}/${invoiceId}`;
  };

  static getAllListCount = () => {
    return BASE_URL + `admin/counts`;
  };

  static downloadTimeSheet = (fileId) => {
    return BASE_URL + `timesheet/download/${fileId}`;
  };

  static updateProfileUser = () => {
    return BASE_URL + "user/currentuserupdate";
  };
  static getExistingInvoices = (userId, projectName, fromDate,page, size) => {
    if (fromDate ) {
      return (
        BASE_URL +
        `admin/existinginvoice/${userId}/${projectName}?fromDate=${fromDate}?page=${page}&size=${size}`
      );
    } else {
      return BASE_URL + `admin/existinginvoice/${userId}/${projectName}?page=${page}&size=${size}`;
    }
  };
  static updateInvoice =(invoiceId)=>{
    return BASE_URL + `admin/updateinvoice/${invoiceId}`;
  }

  static getAllTimesheet =( page, size,)=>{
    return BASE_URL +`timesheet?status=SUB&page=${page}&size=${size}`;
  }
  static getAllTimesheetApp =( page, size) =>{
    return BASE_URL +`admin/allinvoices?paymentDate=null&page=${page}&size=${size}`;
  }
  static reGenerateInvoicePDF = (invoiceId,rate) => {
    return BASE_URL + `admin/generate-pdf?invoiceId=${invoiceId}&hourRate=${rate}`;
  }

  static invoicePaymentDateUpdate = () => {
    return BASE_URL + `admin/update-payment-date`;
  }

  static getEmpTimesheets = () => {
    return BASE_URL + "timesheet/emp-dashboard";
  }

  static getAllAlerts =()=>{
    return BASE_URL +"timesheet/empnotification"
  }

  static getEmpMonthlyHours = () => {
    return BASE_URL + `timesheet/monthly-approved-hours`;
  }
  static getTimesheetCount =()=>{
    return BASE_URL +"timesheet/emptimesheetcounts"
   }
   static getEmpWishes =()=>{
    return BASE_URL +"timesheet/greetings"
   }
   static uploadProfilePicture = () => {
    return BASE_URL + `images/profileimage`;
  }

  static getProfilePicture = () => {
    return BASE_URL + `images/profileimage`;
  }

   static getWeeklyEfficiency =() =>{
    return BASE_URL +"timesheet/efficiency/last-5-weeks"
   }

   static uploadCoverImage =()=>{
    return BASE_URL +"images/uploadcoverimage"
   }

   static getCoverImage =()=>{
   return BASE_URL +"images/coverimage"
   }

   static downloadFileById =(tId,fileId)=>{
    return BASE_URL +"timesheet/download/"+tId+"/"+fileId
   }

  // Time Off API endpoints
  static requestTimeOff = () => {
    return BASE_URL + "timeoff/request";
  };

  static getTimeOffRequests = (page, size, status, sort, startDate, endDate) => {
    let url = BASE_URL + `timeoff/requests?page=${page}&size=${size}&sort=${sort}`;
    if (status) {
      url += `&status=${status}`;
    }
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    return url;
  };

  static getTimeOffById = (id) => {
    return BASE_URL + `timeoff/${id}`;
  };

  static updateTimeOff = (id) => {
    return BASE_URL + `timeoff/${id}`;
  };

  static cancelTimeOff = (id) => {
    return BASE_URL + `timeoff/${id}/cancel`;
  };

  static getAllTimeOffWithoutPagination = () => {

    return BASE_URL + `timeoff/requests-without-pagination`;
  };
}
